import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0a547fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "open_in_new", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "indicator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_indicator = _resolveComponent("message-indicator")!
  const _component_message = _resolveComponent("message")!

  return (_openBlock(), _createBlock(_component_message, {
    message: _ctx.message,
    class: "image-message"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["image", [_ctx.message.sender, !_ctx.message.content.text ? 'no-text' : '']])
      }, [
        _createElementVNode("div", {
          class: "source-image",
          style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.message.content.url + ')' })
        }, [
          _createElementVNode("div", {
            class: "overlay",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openInNewTab()))
          }, _hoisted_2)
        ], 4),
        (_ctx.message.content.text)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.message.content.text) + " ", 1),
              _createVNode(_component_message_indicator, { message: _ctx.message }, null, 8, ["message"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_message_indicator, { message: _ctx.message }, null, 8, ["message"])
            ]))
      ], 2)
    ]),
    _: 1
  }, 8, ["message"]))
}